// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SearchProducts";
import loadCustomerPartNumbers from "@vanmeter/App/Handlers/CPN/loadCustomerPartNumbers";
import { xIsAuthenticated } from "@vanmeter/App/Store/Selectors/GeneralSelectors";

// XNG-Changes: CPN - load customer part numbers for product search dropdowns
const xloadCustomerPartNumbers: typeof RequestDataFromApi = props => {
    const isAuth = xIsAuthenticated(props.getState());

    if (!props.apiResult?.length || !isAuth) {
        return;
    }

    const productIds = props.apiResult.map(product => product.id).filter(Boolean) as string[];

    if (productIds.length === 0) {
        return;
    }

    props.dispatch(
        loadCustomerPartNumbers({
            productIds,
        }),
    );
};

addToChainAfter(chain, RequestDataFromApi, xloadCustomerPartNumbers);
